import axios from "axios";

//const API = import.meta.env.VITE_API_URL;
const API = process.env.REACT_APP_API_URL;

export const login = async (username: string, password: string) => {
  const res = await axios.post(`${API}/auth/login`, { username, password });
  return res.data; // <- pastikan ini bentuknya { token: "...." }
};





